import { GradeConstants as Constants } from '../types'

const initialState = {
    grades: [],    
    error: null,    
    loading: false   
};

export function gradeReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.GET:                     
            return {
                ...state,
                grades: action?.payload?.grades,
                loading: false,
                error: null,
            };   
            
        case Constants.ADD:
            return {
                ...state,
                grades: [...state?.grades, action?.payload?.grade],
                loading: false,
                error: null,
            }

        case Constants.UPDATE:            
            const index = state.grades.findIndex(x => x.id ===  action?.payload?.grade?.id)
            const newArray = [...state.grades];
            if(index > -1)
                newArray[index] = action?.payload?.grade
            return {
                ...state,
                grades: newArray,
                loading: false,
                error: null,
            }   

        case Constants.DELETE:
            return{
                ...state,
                grades: state?.grades?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id)),
                loading: false,
                error: null,
            };

        
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
        default:
            return state
    }
}